const { default: Layout } = process.env.GATSBY_MOBILE
  ? require('./Layout.mobile')
  : require('./Layout');

export default Layout;
